const isProfessionalUser = userType =>
  userType === process.env.REACT_APP_PROFFESIONAL_USERS;

export default isProfessionalUser;
